<template>
  <v-footer :style="{ backgroundColor: $ajustes.colorPie }" padless>
    <v-col class=" text-center white--text py-5" cols="12">
      <v-container class="center" style="color:white;">
        <h2 :style="{ color: $ajustes.colorTexto1 }" class="mb-2 font-weight-bold">{{ $ajustes.textoPie }}</h2>
        <h2 :style="{ color: $ajustes.colorTexto1 }">© {{ new Date().getFullYear() }} Todos los derechos reservados</h2>
        <div class="mt-2">
          <v-btn :style="{ color: $ajustes.colorTexto1 }" icon :href="$ajustes.linkFacebook" target="_blank"
            class="white--text">
            <v-icon>mdi-facebook</v-icon>
          </v-btn>
          <v-btn :style="{ color: $ajustes.colorTexto1 }" dark icon :href="$ajustes.linkInstagram" target="_blank"
            class="white--text">
            <v-icon>mdi-instagram</v-icon>
          </v-btn>
          <v-btn :style="{ color: $ajustes.colorTexto1 }" dark icon :href="'mailto:' + $ajustes.linkEmail"
            class="white--text">
            <v-icon>mdi-email</v-icon>
          </v-btn>
        </div>
      </v-container>
    </v-col>
  </v-footer>
</template>

<script>
export default {
  props: {
    desktop: { type: Boolean },
  },
  data() {
    return {
      footer: false,
    };
  },
  methods: {
    toggleFooter() {
      this.footer = !this.footer;
    },
    btnBrindar() {
      this.$func.openDialog("login");
    },
  },
};
</script>

<style>
.foot {
  position: fixed;
  bottom: 0px;
}

.footM {
  position: fixed;
  bottom: 0px;
  padding-top: 10px;
  border-top: 0.1px solid #00000013;
  width: 100%;
  overflow: hidden;
}
</style>
